<template>
  <div>
    <header class="Header">
      <div class="Header__inner">
        <router-link class="Header_menu__logo Header_menu__logo--sm" to="">
          <img class="Header_menu__logo_img" src="assets/img/melon_logo_blue.png" alt="MELON ONLINE">
        </router-link>
        <div class="Heade__main">
          <div class="Header__menu_area Header__step_area">
            <div class="Step__box">
              <div class="Step__head">
                Step
              </div>
              <div class="Step__circle_line">
                <div class="Step__circle ft_en">
                  <span>1</span>
                </div>
              </div>
              <div class="Step__circle_line">
                <div class="Step__circle Step__circle--active ft_en">
                  <span>2</span>
                </div>
              </div>
              <div class="Step__circle_line">
                <div class="Step__circle ft_en">
                  <span>3</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="contents contents--pt">
      <section class="Form _min-h _min-h-sp">
        <div class="inner">
          <h1 class="Form__head Form__head--mb_md">
            MELON ONLINEご登録フォーム
          </h1>
          <div class="Form__area _show">
            <div :class="`Form__input_box Form__input_box--lg mgt-20 ${getStatus($v.form.reasons_know)}`">
              <div class="Form__input_heda Form__input_head_required">
                今一番改善したいことはなんですか？
              </div>
              <div class="Select__box_area">
                <select v-model="$v.form.reasons_know.$model" class="Select__box" name="item">
                  <option value="">
                    ----選択してください----
                  </option>
                  <option v-for="(reasons_know,value) of inflows" :key="value" :value="reasons_know.id">
                    {{ reasons_know.name }}
                  </option>
                  <optgroup label="" />
                </select>
              </div>
              <div class="Form__error_box">
                <div class="Form__error_tx">
                  きっかけを選択してください
                </div>
              </div>
            </div>

            <div :class="`Form__input_box Form__input_box--lg ${getStatus($v.form.password)}`">
              <div class="Form__input_heda Form__input_head_required">
                ログイン用パスワード
              </div>
              <input
                v-model="$v.form.password.$model"
                class="Form__input"
                type="password"
                placeholder="10文字以上で設定してください"
                autocomplete="off"
              >
              <div class="Form__error_box">
                <div v-if="!$v.form.password.required" class="Form__error_tx">
                  パスワードを入力してください
                </div>
                <div v-if="!$v.form.password.minLength" class="Form__error_tx">
                  10文字以上で設定してください
                </div>
                <div v-if="!$v.form.password.regexPassword" class="Form__error_tx">
                  数字、英字を含めて設定してください
                </div>
              </div>
            </div>
            <div :class="`Form__input_box Form__input_box--lg ${getStatus($v.form.confirm_password)}`">
              <div class="Form__input_heda Form__input_head_required">
                ログイン用パスワード（確認用）
              </div>
              <input
                v-model="$v.form.confirm_password.$model"
                class="Form__input"
                type="password"
                placeholder="10文字以上で設定してください"
                autocomplete="off"
              >
              <div class="Form__error_box">
                <div v-if="!$v.form.confirm_password.required" class="Form__error_tx">
                  パスワードの確認が必要です
                </div>
                <div v-if="!$v.form.confirm_password.sameAsPassword" class="Form__error_tx">
                  パスワードと確認用パスワードが異なっています。
                </div>
              </div>
            </div>
            <button
              class="Btn__blue Form__btn Form__btn--mt_md Form__btn--mt_lg Form__btn--mt_sp_lg"
              @click="nextStep()"
            >
              確認へ進む
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import SignUpLayout from '@/views/layouts/SignUpLayout'
import { validationMixin } from 'vuelidate'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import { regexPassword } from '@/helpers/validations'
import authService from '@/services/authService'

const validations = {
  form: {
    reasons_know: {
      required
    },
    password: {
      required,
      minLength: minLength(10),
      regexPassword
    },
    confirm_password: {
      required,
      sameAsPassword: sameAs('password')
    }
  }
}
export default {
  name: 'RegisterStep2',
  layout: SignUpLayout,
  mixins: [validationMixin],
  validations: validations,
  data() {
    return {
      inflows: []
    }
  },
  computed: {
    ...mapState({
      form: state => state.auth.signUpData
    })
  },
  mounted() {
    this.getDataStep2()
  },
  methods: {
    async getDataStep2() {
      if (localStorage.getItem('step1')) {
        if (localStorage.getItem('step2')) {
          const dataStep2 = localStorage.getItem('step2')
          this.form.reasons_know = JSON.parse(dataStep2).reasons_know
        }
      }
      const response = await authService.getReasonKnow()
      this.inflows = response.reasons_knows
    },
    getStatus(validation) {
      return validation.$error ? '_error' : ''
    },
    nextStep() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        return
      }
      let updateUserInfo = {}
      updateUserInfo = this.form
      this.$store.dispatch('auth/nextStep', updateUserInfo)
      if (this.form.user_type === 'corp-trial') {
        this.$router.push('/corp-trial-member-register/step-3')
      } else {
        this.$router.push('/corpwelfare-member-register/step-3')
      }
    }
  }
}
</script>
